import React from 'react';
import { useIntl } from 'react-intl';
import ToolTipAnchor from '../../../common/tooltip';

interface IAttachImpressionProps {
    side: string;
    patient: any;
    attachmentSide: string;
    fileupload: (event: React.ChangeEvent<HTMLInputElement>) => void;
    updatePatient: (patient: any) => void;
    update: any;
    lookupMessage: any;
    error: string | undefined;
}

export default function AttachImpression({
    side,
    patient,
    attachmentSide,
    fileupload,
    updatePatient,
    update,
    lookupMessage,
    error,
}: IAttachImpressionProps) {
    const intl = useIntl();
    const attachmentSideLower = attachmentSide === 'R' ? 'right' : 'left';
    const attachmentSideCapital = attachmentSide === 'R' ? 'Right' : 'Left';

    const errorColor = '#a94442';
    let wrapperClassInputGroup = 'input-group col-sm-3';
    if (error) {
        wrapperClassInputGroup += ' has-error';
    }

    const toolTipMessage = `
        <div>
        <p class="paragraph-style">${intl.formatMessage({
            id: 'Max_File_Size',
            defaultMessage: 'Max File Size: 20 MB',
        })}</p>
        <p class="paragraph-style">${intl.formatMessage({
            id: 'Allowed_File_Types',
            defaultMessage: 'Allowed File Types:',
        })}</p>
            <ul>
                <li class="list-padding">.hps</li>
                <li class="list-padding">.stl</li>
                <li class="list-padding">.asc</li>
            </ul>
        </div>`;

    return (
        (side === 'B' || side === attachmentSide) && (
            <>
                <div className="tooltip-flex">
                    <p>
                        {intl.formatMessage({
                            id: attachmentSideCapital + '_Impression_Upload',
                            defaultMessage:
                                attachmentSideCapital + ' Impression Upload',
                        })}
                    </p>
                    <ToolTipAnchor toolTipMessage={toolTipMessage} />
                </div>
                <div className={wrapperClassInputGroup}>
                    <input
                        type="text"
                        className="form-control"
                        value={
                            patient!['impression' + attachmentSideCapital]
                                ? patient![
                                      attachmentSideLower + 'ImpressionFileName'
                                  ] || attachmentSideCapital + ' Impression'
                                : ''
                        }
                        style={{
                            backgroundColor: '#eee',
                            pointerEvents: 'none',
                            display: 'inline-block',
                            position: 'relative',
                        }}
                    />
                    {!patient!['impression' + attachmentSideCapital] ? (
                        <div className="input-group-btn">
                            <label
                                className="btn btn-default"
                                style={{
                                    minHeight: '34px',
                                    padding: '6px 12px',
                                    color: error ? errorColor : '#333',
                                    borderColor: error ? errorColor : '#ccc',
                                }}
                            >
                                <span className="far fa-folder-open" />
                                <span>
                                    {lookupMessage[attachmentSideLower]
                                        ? intl.formatMessage({
                                              id: 'Uploading',
                                              defaultMessage: 'Uploading',
                                          }) + '...'
                                        : intl.formatMessage({
                                              id: 'Browse',
                                              defaultMessage: 'Browse',
                                          })}
                                </span>
                                <form
                                    id={attachmentSideLower + 'UploadForm'}
                                    encType="multipart/form-data"
                                >
                                    <input
                                        id={attachmentSideLower + 'Impression'}
                                        name={
                                            attachmentSideLower + 'Impression'
                                        }
                                        style={{
                                            display: 'none',
                                        }}
                                        type="file"
                                        onChange={fileupload}
                                    />
                                </form>
                            </label>
                        </div>
                    ) : (
                        <div className="input-group-btn">
                            <button
                                name={attachmentSideLower + 'ImpressionRemove'}
                                className="btn btn-danger"
                                style={{
                                    minHeight: '34px',
                                    padding: '6px 10px',
                                    color: '#333',
                                    borderColor: '#ccc',
                                }}
                                onClick={() => {
                                    const updateObj =
                                        attachmentSide === 'R'
                                            ? {
                                                  impressionRight: {
                                                      $set: null,
                                                  },
                                                  rightImpressionFileName: {
                                                      $set: null,
                                                  },
                                              }
                                            : {
                                                  impressionLeft: {
                                                      $set: null,
                                                  },
                                                  leftImpressionFileName: {
                                                      $set: null,
                                                  },
                                              };
                                    updatePatient(update(patient!, updateObj));
                                }}
                            >
                                <span className="far fa-file-times" />{' '}
                                <span>
                                    {intl.formatMessage({
                                        id: 'Remove_file',
                                        defaultMessage: 'Remove file',
                                    })}
                                </span>
                            </button>
                        </div>
                    )}
                </div>
            </>
        )
    );
}
